import { NgModule } from '@angular/core';

import { FinishedModule } from '@ap/tokens-browser';

import { FinishedWrapperComponent } from './finished.wrapper.component';

/**
 * @name FinishedWrapperModule
 * @ngdoc module
 */
@NgModule({
    declarations: [FinishedWrapperComponent],
    imports: [FinishedModule],
    exports: [FinishedWrapperComponent]
})
export class FinishedWrapperModule {}
